import { clearFormatting } from './cnpj-alphanumeric'

const CNPJ_ROOT_LENGTH = 8

// retorna a raiz do CNPJ (8 primeiros caracteres), usada para identificar filiais da mesma empresa
export function getCnpjRoot(cnpj) {
  return clearFormatting(cnpj).slice(0, CNPJ_ROOT_LENGTH)
}

// verifica se dois CNPJs pertencem à mesma empresa (matriz/filial)
export function isSameCnpjRoot(cnpjA, cnpjB) {
  const rootA = getCnpjRoot(cnpjA)
  const rootB = getCnpjRoot(cnpjB)
  return !!rootA && !!rootB && rootA === rootB
}

